import React from 'react';
import { Evidence2, DictionaryObject } from '@eas/common-web';

import { useValidationSchema } from './dict-minimal-distances-source-category-schema';
import { EvidenceAPI, PageKey, EntityName } from '../../enums';
import { useDictionaryEvidence } from '../../components/evidence/dictionary-evidence/dictionary-evidence';

export function DictionaryMinimalDistancesSourceCategory() {
  const validationSchema = useValidationSchema();

  const evidence = useDictionaryEvidence<DictionaryObject>({
    identifier: PageKey.DICTIONARY_MINIMAL_DISTANCES_SOURCE_CATEGORY,
    apiProps: {
      url: EvidenceAPI.DICTIONARY_MINIMAL_DISTANCES_SOURCE_CATEGORY,
    },

    tableProps: {
      tableName: 'Zařazení zdroje minimální vzdálenosti',
      defaultSorts: [],
      // reportTag: 'TODO:',
      showReportButton: false,
    },
    detailProps: {
      entityName: EntityName.MINIMAL_DISTANCES_SOURCE_CATEGORY,
      codePrefix: '',
      validationSchema,
      toolbarProps: {
        title:
          'Zařazení zdroje minimální vzdálenosti podle přílohy č. 2a zákona',
      },
    },
  });

  return <Evidence2 {...evidence} />;
}
